const brands = [
  "AUDI", "VOLKSWAGEN", "BMW", "MERCEDES-BENZ", "ŠKODA",
  "PORSCHE", "LAMBORGHINI", "MINI", "RANGE ROVER",
];

export default function Marquee() {
  const items = [...brands, ...brands];
  return (
    <div data-testid="brand-marquee" className="relative z-10 border-y border-white/10 py-8 overflow-hidden bg-[#0a0a0a]">
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((b, i) => (
          <div key={i} className="flex items-center gap-10 px-10">
            <span className="font-display text-3xl md:text-5xl text-white/15 hover:text-white/60 transition-colors">
              {b}
            </span>
            <span className="text-[#ff3b30] text-2xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
